export const locale = {
  messages_link: 'Messages',
  contact_us: 'Contact Us',
  open_menu: 'Open Menu',
};
